import type { Middleware } from "openapi-fetch";
import { acquireMsalToken, initializeMsal, msalInstance } from "../auth/msal.ts";

interface MsalMiddlewareOptions {
    headerName: string;
}

export function setMsalTokenMiddleware({ headerName }: MsalMiddlewareOptions): Middleware {
    return {
        async onRequest({ request }) {
            await initializeMsal();
            // Only set the jwt token if the user is logged in
            if (!msalInstance.getActiveAccount()) {
                return request;
            }

            try {
                const authResult = await acquireMsalToken();
                request.headers.set(headerName, authResult.idToken);
            } catch (error) {
                console.error("Failed to set msal token in request", error);
            }

            return request;
        }
    };
}
